import { PropTypes } from "prop-types"
import classNames from "classnames"

import Translate from "../Translate"
import Button from "../Button"
import { useAccordionContext } from "./AccordionContext"

const AccordionButton = ({ ariaLabel, ariaDescribedBy, children, id, index, toggleLabel }) => {
  const { isOpen, onClick, onKeyDown, ref } = useAccordionContext(index)
  const toggleLabelId = isOpen ? `${toggleLabel}-opened` : `${toggleLabel}-closed`

  return (
    <div className={classNames("oj-accordion-button", { open: isOpen }, { closed: !isOpen })}>
      <Button
        className="accordion-button"
        aria-controls={`elements-${id}`}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        aria-expanded={isOpen}
        id={id}
        buttonRef={ref}
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        {children}
        <span className="toggle-label">
          {toggleLabel && <Translate id={toggleLabelId} />}
          <span role="presentation" className="chevron" />
        </span>
      </Button>
    </div>
  )
}

AccordionButton.propTypes = {
  ariaLabel: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  index: PropTypes.number,
  toggleLabel: PropTypes.string,
  sectionRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
}

AccordionButton.displayName = "AccordionButton"

export default AccordionButton
